<template>
  <div>
    <template v-if="list.length > 0">
      <DoctorListItem
        v-for="item of list"
        :data="item"
        :key="item.id"/>
    </template>
    <div
      v-else
      class="p-5 text-center text-muted">暂无数据</div>
  </div>
</template>

<script>
import DoctorListItem from './DoctorListItem.vue';

export default {
  name: 'DoctorList',
  components: {
    DoctorListItem,
  },
  props: {
    category: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.handleLoad();
  },
  methods: {
    async handleLoad() {
      this.list = await this.$http.get('/cloud-film-api/webapi/professional/get-doctors', {
        category: this.category,
      });
    },
  },
};
</script>
